import styles from "./index.module.scss";
import PhotoAPI from "../../../services/photo-api";

export default function ImageRTC({
  imageId,
  title,
  author,
}: {
  imageId: string;
  title: string;
  author?: string;
}): JSX.Element {
  const src = PhotoAPI.photoFromXX(imageId, "IH", "jpg");
  const srcSet = !!src ? [src, `${src.replace("IH,", "IHR,")} 2x`].join(", ") : "";

  return src ? (
    <div className={styles.rtcImage}>
      <figure className={styles.figure}>
        <picture className={styles.picture}>
          <img className={styles.preview} srcSet={srcSet} src={src} alt={title} />
        </picture>
      </figure>
      <div className={styles.imageCaption}>
        <span>{title}</span>&nbsp;
        {author && <span>{author}</span>}
      </div>
    </div>
  ) : (
    <></>
  );
}
